import React from 'react';
import { useQuery } from '@apollo/client';
import HelpAskPanel from '../components/help/HelpAskPanel';
import HelpArticleList from '../components/help/HelpArticleList';
import HelpSubnav from '../components/help/HelpSubnav';
import { GET_HELP_ARTICLES } from '../graphql/helpContent';

export default function HelpDevelopers() {
  const { data, loading, error } = useQuery(GET_HELP_ARTICLES, {
    variables: { kind: 'DEVELOPERS' },
  });

  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-2xl font-semibold text-white lg:text-gray-900">Developers</h1>
          <p className="mt-1 text-sm text-sky-100 lg:text-gray-600">
            Administrator-only onboarding for a team taking over this codebase.
          </p>
        </div>
        <HelpSubnav />
      </div>
      <HelpAskPanel />
      <HelpArticleList
        articles={data?.helpArticles || []}
        loading={loading}
        error={error}
        emptyMessage="No developer documentation is available."
      />
    </div>
  );
}
